/* Polsk katalog for locale-no.js (del 8 av 10).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'po.todaysPlanBase': 'Dzisiejszy plan — punkt wyjścia',
  'po.editTodaysPlan': 'Edytuj dzisiejszy plan',
  'po.netWealthToday': 'Majątek netto dziś',
  'po.monthlySavingShort': 'Miesięczne oszczędzanie',
  'po.extraDebtRepayment': 'Dodatkowa spłata długu',
  'po.return': 'Stopa zwrotu',
  'po.retirementAge': 'Wiek emerytalny',
  'po.adjustAssumptions': 'Dostosuj założenia',
  'po.lifeEvents': 'Wydarzenia życiowe',
  'po.lifeEventsSub': 'Zaplanuj duże wydarzenia — dzieci, mieszkanie, urlop, rok przerwy — i zobacz, jak kształtują cały obraz przyszłości',
  'po.addEvent': 'Dodaj wydarzenie',
  'po.lifeEventsHelp': 'Wprowadź przyszłe wydarzenia z datą rozpoczęcia, kosztem jednorazowym, efektem miesięcznym i czasem trwania. Każde aktywne wydarzenie zostaje umieszczone w odpowiednim momencie prognozy. Wyłącz wydarzenie, aby zobaczyć plan bez niego. Wydarzenia są zapisywane dla wybranego roku.',
  'po.effectOver5Years': 'Efekt w ciągu 5 lat',
  'po.goalScore': 'Wynik celów',
  'po.goalScoreSub': 'Jak dobrze idzie ci osiąganie celów — i co podnosi wynik',
  'po.whatAffectsGoalScore': 'To wpływa na wynik celów',
  'po.myRecommendationNow': 'Moja rekomendacja w tej chwili',
  'po.prioritise': 'Ustal priorytet',
  'po.talkAboutPlan': 'Porozmawiaj ze mną o planie',
  'po.yourGoals': 'Twoje cele',
  'po.yourGoalsSub': 'Każdy cel z pozostałą kwotą, przewidywaną datą i prawdopodobieństwem',
  'po.newGoal': 'Nowy cel',
  'po.addGoal': 'Dodaj cel',
  'po.editGoal': 'Edytuj cel',
  'po.deleteGoal': 'Usuń cel',
  'po.remaining': 'Pozostało',
  'po.expectedDone': 'Przewidywane osiągnięcie',
  'po.probability': 'Prawdopodobieństwo',
  'po.largestEffect': 'Największy efekt',
  'po.howReachFaster': 'Co mogę zrobić, aby osiągnąć to szybciej?',
  'po.nextMilestone': 'Następny kamień milowy',
  'po.nextMilestoneSub': 'To, co prawdopodobnie osiągniesz najpierw — w kolejności chronologicznej',
  'po.yourLifePlan': 'Twój plan życiowy',
  'po.yourLifePlanSub': 'Najważniejsze przyszłe kamienie milowe finansowe, zbudowane na podstawie twoich celów i planu',
  'po.adjustLive': 'Dostosuj założenia — prognoza, cele i daty aktualizują się na bieżąco podczas przeciągania.',
  'po.deleteGoalTitle': 'Usunąć cel?',
  'po.deleteGoalConfirm': 'Usuń cel',
  'po.doYouWantToDelete': 'Czy chcesz usunąć',
  'po.ownPartnerSharedSub': 'Przegląd twoich kosztów, kosztów partnera i kosztów wspólnych',
  'po.you': 'Ty',
  'po.partner': 'Partner',
  'po.householdSpends': 'Gospodarstwo domowe wydaje',
  'po.reportSub': 'Przeglądaj, porównuj, drukuj i pobieraj raporty miesięczne i roczne',
  'po.print': 'Drukuj',
  'po.downloadPdf': 'Pobierz PDF',
  'po.pdfBusy': 'Tworzenie PDF …',
  'po.pdfFailed': 'Nie udało się utworzyć PDF raportu. Spróbuj ponownie lub użyj opcji Drukuj.',
  'po.pdfFileName': 'raport-finanse-osobiste',
  'po.compareWith': 'Porównaj z',
  'po.compareHelp': 'Umieść obok wcześniejszy okres, aby zobaczyć zmianę. „Wył.” pokazuje tylko wybrany okres.',
  'po.ongoingPeriod': 'Bieżący okres — dane są wstępne',
  'po.plummaSummary': 'Podsumowanie SuperPlummy',
  'po.wentWell': 'To poszło dobrze',
  'po.canImprove': 'To można poprawić',
  'po.focusNextMonth': 'Priorytet na następny miesiąc:',
  'po.goDeeper': 'Chcesz wejść głębiej? Zapytaj mnie o raport.',
  'po.plummaNoticed': 'SuperPlumma zauważyła',
  'po.savingsRate': 'Stopa oszczędności',
  'po.noImportedCosts': 'Brak zaimportowanych kosztów',
  'po.totalCosts': 'Suma kosztów',
  'po.whatHappensNext': 'Co dalej?',
  'po.setAsideOver12': 'Odłożone w ciągu 12 mies.',
  'po.averagePerMonth': 'Średnio miesięcznie',
  'po.askWhatHappensNext': 'Zapytaj mnie, co dalej',
  'po.whatFiguresMean': 'Co oznaczają liczby',
  'po.youHaveStated': 'Podałeś, że',
  'po.howItLooksAhead': 'Tak wygląda przyszłość',
  'po.inSixMonths': 'Za 6 miesięcy',
  'po.inTwelveMonths': 'Za 12 miesięcy',
  'po.assetCategoryPh': 'Np. Nieruchomość',
  'po.assetsAndWealth': 'Aktywa i majątek',
  'po.assetsAndWealthSub': 'Wszystko, co posiadasz, w jednym miejscu — mieszkanie, pojazdy, oszczędności i inwestycje',
  'po.assetsHelp': 'Łączna wartość tego, co posiadasz, twoje długi i majątek netto (aktywa minus długi). „Oczekiwana zmiana wartości” podsumowuje, jak aktywa mają zyskać lub stracić na wartości w ciągu roku.',
  'po.totalAssets': 'Łączne aktywa',
  'po.netWealth': 'Majątek netto',
  'po.expectedChangePerYear': 'Oczekiwana zmiana wartości rocznie',
  'po.liquid': 'Płynne (oszczędności i fundusze)',
  'po.assetCount': 'Liczba aktywów',
  'po.wealthHealth': 'Kondycja majątku',
  'po.wealthHealthSub': 'Ogólna ocena odporności twojego majątku — dywersyfikacja, płynność, ryzyko i wskaźnik zadłużenia',
  'po.wealthStrongestOn': 'Twój majątek wypada najlepiej pod względem',
  'po.wealthDistribution': 'Jak twój majątek rozkłada się na kategorie',
  'po.expectedDevelopment': 'Oczekiwany rozwój',
  'po.expectedDevelopmentSub': 'Na podstawie zmiany wartości wprowadzonej przez ciebie dla każdego aktywa',
  'po.projectionHelp': 'Prognoza wykorzystuje oczekiwaną roczną zmianę wartości wprowadzoną dla każdego aktywa. Plumme nie pobiera jeszcze zewnętrznych danych rynkowych dla nieruchomości, używanych samochodów ani funduszy.',
  'po.withYourAssumptions': 'Przy wprowadzonych założeniach twój majątek zmieni się o około',
  'po.explainSimply': 'Wyjaśnij rozwój w prosty sposób',
  'po.watchingClosely': 'Pod szczególną obserwacją',
  'po.watchingCloselySub': 'Aktywa, które mają stracić na wartości lub rosnąć wolniej niż inflacja',
  'po.explain': 'Wyjaśnij',
  'po.yourAssets': 'Twoje aktywa',
  'po.yourAssetsSub': 'Dotknij aktywa, aby edytować wartość i szczegóły',
  'po.addAsset': 'Dodaj aktywo',
  'po.askAboutTax': 'Zapytaj mnie o podatek',
  'po.taxAssistant': 'Asystent skattemelding',
  'po.taxAssistantSub': 'SuperPlumma prowadzi cię krok po kroku i na bieżąco dostosowuje pytania',
  'po.deductionHunter': 'Łowca odliczeń',
  'po.deductionHunterSub': 'Odliczenia są posortowane według oczekiwanej wartości — zacznij od góry, gdzie zysk jest największy',
  'po.whyIThinkThis': 'Dlaczego tak uważam?',
  'po.dataIUsed': 'Dane, z których skorzystałam',
  'po.whyYouQualify': 'Dlaczego przysługuje ci odliczenie',
  'po.estimatedTaxBenefit': 'Szacowana korzyść podatkowa',
  'po.taxOptimisation': 'Optymalizacja podatkowa',
  'po.taxOptimisationSub': 'Konkretne działania posortowane według terminu — i co oznaczają dla tego i następnego roku',
  'po.nextYearOnwards': 'Następny rok i kolejne',
  'po.aiTaxCheck': 'Kontrola podatkowa AI',
  'po.aiTaxCheckSub': 'SuperPlumma przegląda zaimportowane przez ciebie dane podatkowe',
  'po.readyToFile': 'Gotowe do kontroli zewnętrznej',
  'po.readyToFileSub': 'Porównaj podstawę ze skattemelding i zestawieniami rocznymi',
  'po.checkBasis': 'Podstawa kontroli',
  'po.requiresIntegration': 'Wymaga oficjalnej integracji, silnego uwierzytelnienia i wyraźnej zgody',
  'po.filingUnavailable': 'Wysyłka niedostępna',
  'po.whatIsMissing': 'Czego brakuje przed kontrolą zewnętrzną?',
  'po.whatRemains': 'Pozostało do zrobienia',
  'po.taxBasisNotFetched': 'Podstawa opodatkowania nie została pobrana',
  'po.alreadyVerified': 'Już zweryfikowane',
  'po.nothingVerified': 'Nic nie zostało jeszcze zweryfikowane.',
  'spx.taxScheme': 'System podatkowy i opłat',
  'spx.noItems': 'Brak zarejestrowanych pozycji.',
  'spx.removeSpec': 'Usuń specyfikację',
  'prd.import': 'Importuj produkty',
  'prd.excel': 'Excel (.xlsx)',
  'prd.export': 'Eksportuj produkty',
  'prd.csvName': 'Produkty CSV',
  'prd.excelName': 'Produkty Excel',
  'prd.countTemplateName': 'Szablon spisu z natury',
  'prd.countTemplateEmpty': 'Brak towarów do policzenia. Szablon spisu obejmuje produkty typu Towar.',
  'prd.countTemplateDone': 'Szablon spisu pobrany. Wpisz ilości na dzień 31.12. i pamiętaj, że zapasy wycenia się po cenie nabycia.',
  'prd.countTemplateError': 'Nie udało się utworzyć szablonu spisu.',
  'prd.colProductId': 'ID produktu',
  'prd.colInventoryAccount': 'Konto magazynowe',
  'prd.colStockToday': 'Stan dzisiaj',
  'prd.colCountedQuantity': 'Policzona ilość',
  'prd.colTotalCostValue': 'Łączna wartość według kosztu',
  'prd.colNote': 'Uwaga',
  'prd.countSheetTitle': 'Spis z natury',
  'prd.countSheetIntro': 'Ilość i koszt jednostkowy są wstępnie wypełnione na podstawie dzisiejszego rejestru produktów. Sprawdź i popraw je według faktycznego spisu w dniu spisu.',
  'prd.countSheetDate': 'Data spisu',
  'prd.countSheetCountedBy': 'Spisał(a)',
  'prd.countSheetReference': 'Odniesienie',
  'prd.countSheetSignature': 'Podpis',
  'prd.countSheetNoteLabel': 'Uwaga',
  'prd.countSheetNote': 'Ta lista dokumentuje spis. Wartość księgowa i wartość podatkowa są oceniane podczas zamknięcia roku.',
  'prd.countSheetInfoTab': 'Informacje',
  'prd.countSheetWrongTemplate': 'Użyj szablonu spisu z Plumme. Kolumny się nie zgadzają.',
  'prd.countSheetOnlyXlsx': 'Automatyczny import obsługuje szablon Excel (.xlsx). Inne pliki są zapisywane jako dokumentacja.',
  'prd.countSheetTabNotFound': 'Nie znaleziono arkusza {name}.',
  'prd.countSheetRowError': 'Wiersz {row}: sprawdź towar, konto magazynowe, policzoną ilość i koszt.',
  'prd.countSheetNoneCounted': 'Na liście spisu nie znaleziono wypełnionych ilości.',
  'prd.countSheetUnmappedAccount': 'Konta magazynowego {account} nie można przypisać automatycznie. Sprawdź konta podczas przeglądu.',
  'prd.filterHelp': 'Filtruj produkty według typu (towar, usługa, wynajem), dostępności w magazynie oraz tego, czy pokazywać usunięte.',
  'prd.listTitle': 'Lista produktów',
  'prd.listSub': 'Towary i usługi, które sprzedajesz',
  'prd.new': 'Nowy produkt',
  'prd.searchPh': 'Szukaj po nazwie produktu, opisie, numerze artykułu lub cenie',
  'prd.searchHelp': 'Szukaj po nazwie produktu, opisie, numerze artykułu lub cenie.',
  'prd.none': 'Brak produktów',
  'prd.listHelpTitle': 'Lista produktów',
  'prd.listHelp': 'Każdy wiersz to jeden produkt z numerem art., ceną, stawką VAT, typem i stanem magazynowym. Dotknij wiersza, aby zobaczyć szczegóły i edytować.',
  'prd.detailsTitle': 'Szczegóły produktu',
  'prd.detailsHelp': 'Opis, numer artykułu, cena netto, stawka VAT, typ i stan magazynowy produktu.',
  'prd.editHelp': 'Zmień nazwę, cenę, VAT, typ i stan magazynowy produktu.',
  'prd.delete': 'Usuń produkt',
  'prd.deleteHelp': 'Przenieś produkt do usuniętych. Możesz go później przywrócić.',
  'prd.itemNo': 'Nr art.',
  'prd.colStockItem': 'Towar',
  'prd.stockReasonDefault': 'Spis fizyczny',
  'prd.stock': 'Magazyn',
  'prd.deleted': 'Usunięty',
  'prd.pickOwnColour': 'Wybierz własny kolor',
  'prd.namePh': 'Np. Godzina konsultacji',
  'prd.priceExVat': 'Cena netto',
  'prd.price': 'Cena',
  'prd.priceIncVat': 'Cena brutto',
  'prd.subscriptionPeriod': 'Okres subskrypcji',
  'prd.multiDayDiscount': 'Rabat wielodniowy',
  'prd.multiDayHelp': 'Dotyczy tylko tego produktu do wynajmu.',
  'prd.day2ChargedAt': 'Dzień 2 naliczany jest w wysokości',
  'prd.day3Onwards': 'Dzień 3 i kolejne',
  'prd.itemNumber': 'Numer artykułu',
  'prd.accountFallbackName': 'Konto',
  'prd.acct3000': 'Sprzedaż i pobrania opodatkowane VAT',
  'prd.acct3020': 'Przychody ze sprzedaży usług, wysoka stawka VAT',
  'prd.acct3030': 'Przychody ze sprzedaży towarów, średnia stawka VAT',
  'prd.acct3050': 'Przychody ze sprzedaży towarów, niska stawka VAT',
  'prd.acct3100': 'Sprzedaż i pobrania z 0 procent VAT',
  'prd.acct3200': 'Sprzedaż i pobrania poza ustawą o VAT',
  'prd.acct3900': 'Pozostałe przychody operacyjne',
  'prd.colProductName': 'Nazwa produktu',
  'prd.colDescription': 'Opis',
  'prd.colVat': 'VAT',
  'prd.colType': 'Typ',
  'prd.colRentalDiscount': 'Rabat na wynajem',
  'prd.colSalesAccount': 'Konto sprzedaży',
  'prd.colEquivalentAccount': 'Odpowiada kontu standardowemu',
  'prd.excelImportUnavailable': 'Import z Excela nie jest jeszcze dostępny.',
  'prd.excelExportUnavailable': 'Eksport do Excela nie jest jeszcze dostępny.',
  'prd.colStatus': 'Status',
  'prd.exportSheetName': 'Produkty',
  'prd.typeHeading': 'Nagłówek',
  'prd.typeTextLine': 'Wiersz tekstu',
  'prd.textLinesTitle': 'Wiersze tekstu',
  'prd.newTextLine': 'Nowy wiersz tekstu',
  'prd.updateTextLine': 'Zaktualizuj wiersz tekstu',
  'prd.saveTextLine': 'Zapisz wiersz tekstu',
  'prd.textLineNamePh': 'Np. Standardowy tekst montażowy',
  'prd.textLineTextPh': 'Wpisz tekst, którego można używać w wierszach dokumentów',
  'prd.styleFor': 'Styl dla: {target}',
  'prd.styleTargetText': 'Tekst',
  'prd.styleTargetName': 'Nazwa',
  'prd.styleBold': 'Pogrubienie',
  'prd.styleItalic': 'Kursywa',
  'prd.styleDivider': 'Linia oddzielająca',
  'prd.styleNoDivider': 'Bez linii oddzielającej',
  'prd.styleSummary': 'Nazwa: {name} · Tekst: {text} · {divider}',
  'prd.toastProductUpdated': 'Produkt zaktualizowany',
  'prd.toastProductSaved': 'Produkt zapisany',
  'prd.toastProductSaveError': 'Nie udało się zapisać produktu.',
  'prd.toastProductDeleted': 'Produkt usunięty',
  'prd.toastProductDeleteError': 'Nie udało się usunąć produktu.',
  'prd.toastTextLineUpdated': 'Wiersz tekstu zaktualizowany',
  'prd.toastTextLineSaved': 'Wiersz tekstu zapisany',
  'prd.toastTextLineSaveError': 'Nie udało się zapisać wiersza tekstu.',
  'prd.toastTextLineDeleted': 'Wiersz tekstu usunięty',
  'prd.toastTextLineDeleteError': 'Nie udało się usunąć wiersza tekstu.',
  'prd.toastImportNoneFound': 'Nie znaleziono produktów w pliku.',
  'prd.toastImportSuccess': 'Zaimportowane produkty: {count}',
  'prd.toastImportError': 'Nie udało się zaimportować produktów.',
  'prd.toastExportNone': 'Brak produktów do eksportu',
  'prd.toastExportDone': 'Lista produktów pobrana',
  'prd.toastExportError': 'Nie udało się wyeksportować listy produktów.',
  'prd.textLineFilterHelp': 'Filtruj zapisane wiersze tekstu i nagłówki.',
  'prd.filterOther': 'Inne',
  'prd.showDeleted': 'Pokaż usunięte',
  'prd.typeGoods': 'Towar',
  'prd.typeService': 'Usługa',
  'prd.typeRental': 'Wynajem',
  'prd.typeSubscription': 'Subskrypcja',
  'prd.stockOnly': 'Tylko dostępne w magazynie',
  'prd.textLineSubtitle': 'Zapisane teksty i nagłówki do dokumentów sprzedaży',
  'prd.titleHelp': 'Twoje produkty — towary i usługi, które sprzedajesz, z ceną, VAT i stanem magazynowym. Dotknij produktu, aby zobaczyć szczegóły.',
  'prd.uploadHelp': 'Importuj produkty z pliku.',
  'prd.downloadHelp': 'Pobierz listę produktów jako CSV lub Excel.',
  'prd.addHelp': 'Dodaj nowy towar, usługę, subskrypcję lub produkt do wynajmu.',
  'prd.textLineSearchPh': 'Szukaj po nazwie, tekście lub typie',
  'prd.textLineSearchHelp': 'Szukaj w zapisanych wierszach tekstu i nagłówkach.',
  'prd.emptyText': 'Dodaj towary i usługi, które sprzedajesz, a fakturowanie pójdzie błyskawicznie.',
  'prd.textLineEmptyTitle': 'Brak wierszy tekstu',
  'prd.textLineEmptyText': 'Zapisuj stałe teksty, nagłówki i opisy produktów bez ceny.',
  'prd.colBalance': 'Stan',
  'prd.colCostPerUnit': 'Koszt na jednostkę',
  'prd.colTotalValue': 'Wartość łączna',
  'prd.colStockAvailable': 'Magazyn/dostępne',
  'prd.noneShort': 'Brak',
  'prd.subscriptionLabel': 'Subskrypcja · {period}',
  'prd.month1Short': '1 mies.',
  'prd.months12Short': '12 mies.',
  'prd.copyToTextLine': 'Kopiuj do wiersza tekstu',
  'prd.colProduct': 'Produkt',
  'prd.colPrice': 'Cena',
  'prd.colName': 'Nazwa',
  'prd.colStyle': 'Styl',
  'prd.errNrTaken': 'Numer artykułu „{nr}” jest już używany.',
  'prd.errAccountCodeFormat': 'Użyj konta przychodów, które zaczyna się od 3 i ma 4 lub 5 cyfr.',
  'prd.errAccountNameRequired': 'Nadaj kontu nazwę.',
  'prd.errAccountEquivalentRequired': 'Wybierz konto standardowe, któremu ma odpowiadać to konto.',
  'prd.errAccountExists': 'Konto {code} już istnieje.',
  'prd.errCostPriceInvalid': 'Cena kosztowa musi być prawidłową kwotą wynoszącą co najmniej 0.',
  'prd.errTrackingDateRequired': 'Wybierz datę rozpoczęcia automatycznej gospodarki magazynowej.',
  'prd.errStockNegative': 'Stan początkowy nie może być ujemny.',
  'prd.errCostPriceRequired': 'Wprowadź cenę nabycia dla stanu początkowego.',
  'prd.errCostPriceNegative': 'Cena nabycia nie może być ujemna.',
  'prd.noName': 'Bez nazwy',
  'prd.updateProduct': 'Zaktualizuj produkt',
  'prd.saveProduct': 'Zapisz produkt',
  'prd.rentalQtyLabel': 'Ilość dostępna do wynajmu',
  'prd.autoInventoryTitle': 'Automatyczny magazyn i koszt towarów',
  'prd.autoInventoryHelp': 'Zakupy zwiększają stan magazynu. Zaksięgowana sprzedaż zmniejsza stan i ujmuje obliczony koszt towarów według średniej ważonej.',
  'prd.calculatedStock': 'Obliczony stan magazynowy',
  'prd.openingStock': 'Stan początkowy',
  'prd.avgCostPrice': 'Średnia cena nabycia',
  'prd.costPerUnit': 'Cena nabycia za jednostkę',
  'prd.inventoryValueLine': 'Wartość zapasów: {value}',
  'prd.month1': '1 miesiąc',
  'prd.months12': '12 miesięcy',
  'prd.advancedTitle': 'Zaawansowane dane produktu',
  'prd.advancedHelp': 'SKU, EAN/GTIN, grupa produktów i dane importu.',
  'prd.noGroup': 'Brak grupy',
  'prd.removeGroup': 'Usuń grupę produktów',
  'prd.newGroupPh': 'Nowa grupa produktów',
  'prd.brand': 'Marka',
  'prd.variantName': 'Nazwa wariantu',
  'prd.supplierItemNumber': 'Nr artykułu dostawcy',
  'prd.internalReference': 'Odniesienie wewnętrzne',
  'prd.tags': 'Tagi',
  'prd.tagsPh': 'Np. sklep internetowy, część zamienna, zima',
  'prd.saveAsTextLineTitle': 'Zapisz także jako wiersz tekstowy',
  'prd.saveAsTextLineHelp': 'Tworzy kopię bez ceny do wierszy dokumentów.',
  'prd.autoAccountLine': 'Automatycznie: {account}',
  'prd.accountTypeLabel': 'Typ konta',
  'prd.selectAccount': 'Wybierz konto',
  'prd.customAccountOption': 'Własne',
  'prd.accountInLedger': 'Konto księgowe',
  'prd.accountNamePh': 'Refakturowanie',
  'prd.equivalentForYearEnd': 'Odpowiednik dla sprawozdania finansowego/podatku',
  'prd.selectStandardAccount': 'Wybierz konto standardowe',
  'sub.tabsHelp': 'Przełączaj między subskrypcjami z fakturowaniem cyklicznym a listami klientów do zbiorczego fakturowania lub wysyłki e-maili.',
  'sub.start': 'Początek',
  'sub.end': 'Koniec',
  'sub.endHelp': 'Pozostaw puste, aby kontynuować do czasu wstrzymania lub usunięcia subskrypcji.',
  'sub.internalComment': 'Komentarz wewnętrzny',
  'sub.saveCustomers': 'Zapisz klientów',
  'sub.searchCustomers': 'Szukaj klientów',
  'sub.searchCustomersPh': 'Szukaj po nazwie, e-mailu lub nr org...',
  'sub.selectVisible': 'Zaznacz widoczne',
  'sub.deselectVisible': 'Odznacz widoczne',
  'sub.noCustomers': 'Brak klientów',
  'sub.howToInvoice': 'Jak chcesz fakturować?',
  'sub.manualFlowNote': 'Poniższy wybór uruchamia ręczny proces fakturowania dla subskrypcji.',
  'sub.sendInvoice': 'Wyślij fakturę',
  'sub.openDraftFilled': 'Otwórz szkic faktury z wypełnioną subskrypcją.',
  'sub.openBlankDraft': 'Otwórz pusty szkic faktury z wybraną grupą klientów.',
  'sub.subject': 'Temat',
  'sub.message': 'Wiadomość',
  'sub.removeAllAttachments': 'Usuń wszystkie załączniki',
  'sub.addCustomers': 'Dodaj klientów',
  'sub.noInvoiceSent': 'Nie wysłano faktury',
  'sub.noEmailSent': 'Nie wysłano e-maila',
  'sub.unknownCustomer': 'Nieznany klient',
  'sub.customersCount': 'Klienci: {count}',
  'sub.cpiAnnualSuffix': ' · CPI {rate} % rocznie',
  'sub.actionMenuLabel': 'Działanie',
  'sub.nameRequiredSubscription': 'Nadaj nazwę subskrypcji',
  'sub.nameRequiredList': 'Nadaj nazwę liście',
  'sub.nameRequiredListError': 'Nadaj nazwę liście.',
  'sub.nameRequiredAgreementError': 'Nadaj nazwę umowie.',
  'sub.editSubTitle': 'Edytuj subskrypcję',
  'sub.editListTitle': 'Edytuj listę',
  'sub.newSubTitle': 'Nowa subskrypcja',
  'sub.newListTitle': 'Nowa lista',
  'sub.saveChanges': 'Zapisz zmiany',
  'sub.saveSubscription': 'Zapisz subskrypcję',
  'sub.saveList': 'Zapisz listę',
  'sub.namePlaceholderSub': 'Np. Członkostwo Gold',
  'sub.namePlaceholderList': 'Np. Newsletter',
  'sub.nextInvoiceDateLabel': 'Następna data faktury',
  'sub.cpiAdjustmentLabel': 'Waloryzacja CPI',
  'sub.cpiAdjustmentHelp': 'Coroczna waloryzacja ceny subskrypcji wskaźnikiem cen konsumpcyjnych.',
  'sub.customerSavedToast': 'Klient „{name}” zapisany',
  'sub.saveCustomerError': 'Nie udało się zapisać klienta.',
  'sub.addCustomersTitle': 'Dodaj klientów · {name}',
  'sub.selectedCount': 'Wybrano: {count}',
  'sub.addAsNewCustomer': 'Dodaj „{name}” jako nowego klienta',
  'sub.noContactInfo': 'Brak danych kontaktowych',
  'sub.addCustomersEmptyText': 'Najpierw dodaj klientów do rejestru klientów lub wpisz nazwę, aby utworzyć nowego.',
  'sub.sendInvoiceTitle': 'Wyślij fakturę · {name}',
  'sub.attachmentTooLarge': 'Załączniki mogą mieć maksymalnie {max}.',
  'sub.fillSubject': 'Uzupełnij temat.',
  'sub.writeMessage': 'Napisz wiadomość.',
  'sub.sendEmailTitle': 'Wyślij e-mail · {name}',
  'sub.sending': 'Wysyłanie...',
  'sub.sendEmailButton': 'Wyślij e-mail',
  'sub.readyCount': 'Gotowe: {count}',
  'sub.attachmentsAddedCount': 'Dodane załączniki: {count}',
  'sub.addAttachment': 'Dodaj załącznik',
  'sub.emailSendNote': 'E-maile są wysyłane przez serwer. Możesz upuścić pliki w dowolnym miejscu okna lub wkleić je za pomocą Ctrl+V. Odbiorcy bez adresu e-mail są rejestrowani jako niewysłani.',
  'sub.typeSubscription': 'Subskrypcja',
  'sub.typeList': 'Lista',
  'sub.actionClose': 'Zamknij',
  'sub.actionOpen': 'Otwórz',
  'sub.edit': 'Edytuj',
  'sub.emailLabel': 'E-mail',
  'sub.resume': 'Wznów',
  'sub.pause': 'Wstrzymaj',
  'sub.delete': 'Usuń',
  'sub.tabCustomers': 'Klienci ({count})',
  'sub.tabInvoices': 'Faktury ({count})',
  'sub.tabEmails': 'E-maile ({count})',
  'sub.addCustomersToInvoiceText': 'Dodaj klientów, aby wystawiać im faktury.',
  'sub.removeMember': 'Usuń',
});
